const state = {
    filter: {},
    filters: [],
    pageSize: 25,
    currentPage: 1,
    pageStart: 1,
    pageEnd: 10,
    maxPage: 1,
    orderBy: "desc",
    context: "",
    pageBefore: "",
};

const mutations = {
    datatable_currentPage: function (state, payload) {
        state.currentPage = payload;
    },

    datatable_pageSize: function (state, payload) {
        state.pageSize = payload;
    },

    datatable_maxPage: function (state, payload) {
        state.maxPage = payload;
    },

    datatable_orderby: function (state, payload) {
        state.orderBy = payload;
    },

    datatable_push_filter: function (state, payload) {
        state.filter = payload;
    },

    datatable_push_filters: function (state, payload) {
        state.filters.push(payload);
    },

    datatable_clear_filter: function (state) {
        state.filter = {};
        state.orderBy = "desc";
    },

    datatable_clear_filters: function (state) {
        state.filters = [];
        state.orderBy = "desc";
    },

    datatable_delete_one_filters: function (state, payload) {
        state.filters.splice(payload, 1);
        state.orderBy = "desc";
    },

    datatable_context: function (state, payload) {
        state.context = payload;
    },

    datatable_pageStart: function (state, payload) {
        state.pageStart = payload;
    },

    datatable_pageEnd: function (state, payload) {
        state.pageEnd = payload;
    },

    datatable_page_before: function (state, payload) {
        state.pageBefore = payload;
    },
};

export default {
    state,
    mutations,
};



// WEBPACK FOOTER //
// ./src/modules/global/stores/datatable.js